import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';
import NumberFormatter from 'portaltransparencia-common/components/NumberFormatter.react.js';
import SumListField from 'portaltransparencia-common/components/SumListField.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';

const MESES = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro'
];

export class RepasseDetalhe extends Component {
  static propTypes = {
    repasses: PropTypes.object.isRequired,
    tipo: PropTypes.string.isRequired,
    mesInicial: PropTypes.number,
    mesFinal: PropTypes.number
  };

  getValorMes = (mes, campo) => {
    const { repasses, mesInicial = 1, mesFinal = 12 } = this.props;
    if (mes < mesInicial || mes > mesFinal) return null;
    const item = repasses.find(r => r.get('mes') === mes);
    return item ? item.get(campo) : null;
  };

  renderMes = (nomeMes, mesNum) => {
    return (
      <tr key={mesNum}>
        <td>{nomeMes}</td>
        <td className="right">
          <NumberFormatter value={this.getValorMes(mesNum, 'valorPrevisto')} />
        </td>
        <td className="right">
          <NumberFormatter value={this.getValorMes(mesNum, 'valorRecebido')} />
        </td>
        <td className="right">
          <NumberFormatter value={this.getValorMes(mesNum, 'valorDevolvido')} />
        </td>
      </tr>
    );
  };

  renderRecebidos() {
    const { repasses, mesInicial = 1, mesFinal = 12 } = this.props;
    const repassesFiltrados = repasses.filter(
      r => r.get('mes') >= mesInicial && r.get('mes') <= mesFinal
    );

    return (
      <div className="panel-table-outer">
        <table className="panel-table striped fancy">
          <TableHeader width="100%">
            <tr>
              <th>Mês</th>
              <th style={{ textAlign: 'right' }}>Valor Previsto</th>
              <th style={{ textAlign: 'right' }}>Valor Recebido</th>
              <th style={{ textAlign: 'right' }}>Valor Devolvido</th>
            </tr>
          </TableHeader>
          <tbody>
            {MESES.map((nome, idx) => this.renderMes(nome, idx + 1))}
          </tbody>
          <tfoot>
            <tr>
              <td>
                <i>Total</i>
              </td>
              <td className="right">
                <SumListField
                  fieldName="valorPrevisto"
                  list={repassesFiltrados}
                />
              </td>
              <td className="right">
                <SumListField
                  fieldName="valorRecebido"
                  list={repassesFiltrados}
                />
              </td>
              <td className="right">
                <SumListField
                  fieldName="valorDevolvido"
                  list={repassesFiltrados}
                />
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  }

  renderRepasseEnviado = data => {
    const key = `${data.get('data')}_${data.get('valor')}_${data.get(
      'conta'
    )}_${data.get('idContaCorrente')}_${data.get('nroLancamento')}`;
    return (
      <tr key={key}>
        <td colSpan={2}>{DateUtils.formatDateTimeShort(data.get('data'))}</td>
        <td colSpan={9}>{data.get('local')}</td>
        <td colSpan={9}>{data.get('compHist')}</td>
        <td colSpan={1} className="right">
          <NumberFormatter value={data.get('valor')} />
        </td>
      </tr>
    );
  };

  renderEnviados() {
    const { repasses } = this.props;

    return (
      <div className="panel-table-outer">
        <table className="panel-table striped fancy">
          <TableHeader width="100%" empty={repasses.isEmpty()}>
            <tr>
              <th colSpan={2}>Data do Repasse</th>
              <th colSpan={9}>Banco</th>
              <th colSpan={9}>Histórico</th>
              <th style={{ textAlign: 'right' }} colSpan={1}>
                Valor
              </th>
            </tr>
          </TableHeader>
          <tbody>{repasses.map(this.renderRepasseEnviado)}</tbody>
          {!repasses.isEmpty() && (
            <tfoot>
              <tr>
                <td colSpan={2}></td>
                <td colSpan={9}></td>
                <td colSpan={9}></td>
                <td colSpan={1} className="right">
                  <i>Total: </i>
                  <SumListField fieldName="valor" list={repasses} />
                </td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    );
  }

  render() {
    const { tipo } = this.props;

    return (
      <section>
        {tipo === 'R' ? this.renderRecebidos() : this.renderEnviados()}
      </section>
    );
  }
}

export default RepasseDetalhe;
